<template>
	<v-main>
        <v-container>
            <!-- <v-toolbar elevation="0">
				<v-btn icon color="primary" @click="$router.push('/')">
					<v-icon>mdi-home</v-icon>
				</v-btn>
				<v-toolbar-title class="font-weight-light">{{ $vuetify.lang.t('$vuetify.' + title) | capitalize }}</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar> -->

			<v-data-table
				v-model="selected"
				:headers="headers"
				:items="items"
				item-key="id"
				show-select
				:loading="loading"
				:search="searchText"
				loading-text="Завантаження даних... зачекайте, будь ласка." 
			>
			<!-- :items-per-page="-1"
				hide-default-footer -->
				<template v-slot:top>
					<v-toolbar flat>
						<v-app-bar-nav-icon>
							<v-icon>{{ icon }}</v-icon>
						</v-app-bar-nav-icon>
						<v-toolbar-title>{{ $vuetify.lang.t(`$vuetify.${title}`) | capitalize }}</v-toolbar-title>
						<v-spacer></v-spacer>

						<v-spacer></v-spacer>
						<v-text-field
							v-model="searchText"
							append-icon="mdi-magnify"
							label="Пошук"
							dense
							single-line
							hide-details
							outlined
							rounded
						></v-text-field>
						<!-- Оновити -->
						<v-btn icon @click="onRefresh">
							<v-icon>mdi-refresh</v-icon>
						</v-btn>
					</v-toolbar>
				</template>

				
				<template v-slot:[`item.active`]="{ item }">
					<v-tooltip bottom v-if="item.active">
						<template v-slot:activator="{ on, attrs }">
							<v-icon v-bind="attrs" v-on="on" color="success">mdi-circle</v-icon>
						</template>
						<span>{{ item.dateactive | formatDateTime }}</span>
					</v-tooltip>
				</template>
				<template v-slot:[`item.actions`]="{ item }">
					<v-toolbar flat dense color="transparent">
						<z-detail v-model="item" @update="edit(item, $event)">
							<template v-slot:activator="props">
								<v-icon class="mx-3" v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">mdi-pencil</v-icon>
							</template>
						</z-detail>
						<v-menu offset-y ref="menu">
							<template v-slot:activator="{ on, attrs }">
								<v-icon class="mx-3" v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
							</template>
							<v-list>

								<!-- <z-detail v-if="permitionUpdate"
									:selected="item"
									@close="onClose"
									@update="edit(item, $event)"
								>
									<template v-slot:activator="props">
										<v-list-item v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
											<v-list-item-icon>
												<v-icon>mdi-pencil</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Редагувати</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</template>
								</z-detail> -->

								<z-dialog-estimate :park="item">
									<template v-slot:activator="props">
										<v-list-item v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
											<v-list-item-icon>
												<!-- <v-icon color="green">mdi-play-circle</v-icon> -->
												<v-icon>mdi-ruler-square-compass</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Створити оцінку</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</template>
								</z-dialog-estimate>

								<!-- <v-list-item>
									<v-list-item-icon>
										<v-icon>mdi-ruler-square-compass</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Оцінка</v-list-item-title>
									</v-list-item-content>
								</v-list-item> -->

								<v-divider></v-divider>

								<z-confirm-delete @ok="onDelete(item)" activator-type="list-item"></z-confirm-delete>
								
								
								<!-- <v-list-item v-if="item.disabled" @click="onUnlock(item)">
									<v-list-item-icon>
										<v-icon>mdi-account-check</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Розблокувати</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item v-else @click="onLock(item)">
									<v-list-item-icon>
										<v-icon>mdi-account-cancel</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Заблокувати</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								
								<v-divider v-if="permitionPasswordRenew"></v-divider>
								<v-list-item v-if="permitionPasswordRenew" @click="onPasswordRenew(item)">
									<v-list-item-icon>
										<v-icon>mdi-key-arrow-right</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Відновити пароль</v-list-item-title>
									</v-list-item-content>
								</v-list-item> -->
							</v-list>
						</v-menu>
					</v-toolbar>
				</template>
			</v-data-table>

			
		</v-container>

		<z-detail tooltip="create" @create="add">
			<template v-slot:activator="props">
				<v-fab-transition>
					<v-btn
						v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}"
						color="primary"
						dark
						fixed
						bottom
						right
						fab
						class="mb-8 mr-8"
						@create="add"
					>
						<v-icon>mdi-plus</v-icon>
					</v-btn>
				</v-fab-transition>
			</template>
		</z-detail>
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>

		<!-- <v-snackbar v-model="snackbar.visible">
			{{ snackbar.text }}
			<template v-slot:actions>
				<v-btn icon="mdi-window-close" @click="snackbar.visible = false"></v-btn>
			</template>
		</v-snackbar> -->
    </v-main>
</template>

<script>
//import axios from 'axios'
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
import downloadExcel from "vue-json-excel"
//import zDetail from '@/views/dialogs/details/VehiclePark'
import zDetail from '@/views/dialogs/details/VehiclePark2'
import zDialogEstimate from '@/views/dialogs/VehicleParkEstimate'
import zConfirmDelete from '@/views/components/dialogs/ConfirmDelete'

export default {
	name: 'VehiclePark',
	mixins: [mixin],
	components: {
		downloadExcel,
		zDetail, zDialogEstimate,
		zConfirmDelete,
	},
	data: () => ({
		title: 'parks',
		icon: 'mdi-car-2-plus',
		searchText: '',
		headers: [
			//{ text: 'ID', value: 'id', align: ' d-none' },
			{ text: 'ID', value: 'id', sortable: true},
			{ text: 'Код', value: 'code', sortable: true},
			{ text: 'Назва', value: 'name', sortable: true},
			{ text: 'Опис', value: 'description', sortable: true},
			{ text: 'Авто', value: 'vehicles.length', sortable: true},
			{ text: 'Оцінки', value: 'estimates.length', sortable: true},
			{ text: '', value: 'actions', sortable: false, width: '10%' },
		],

		page: 1,
		pageCount: 2,
		itemsPerPage: 15,

		/* snackbar: {
			visible: false,
			text: null
		}, */
	}),
	
	computed: {
		...mapGetters('VehiclePark', [ 'items' ]),
	},

	methods: {
		...mapActions(['showMessage']),
		...mapActions('VehiclePark', [ 'search', 'delete' ]),

		onRefresh() {
			this.loading = true
			return this.search().finally(() => (this.loading = false));
		},
	},
}
</script>